(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .directive('lineChart', lineChartDirective)
    .controller('lineChartController', lineChartController);

  /** @ngInject */
  function lineChartDirective($timeout) {
    return {
      restrict: 'E',
      scope: {
        options: '=',
        leftPadding: '<',
        chartId: '@',
        subChart: '=?',
        chartDataName: '='
      },
      templateUrl: 'app/components/lineChart/lineChart.html',
      controller: 'lineChartController',
      controllerAs: 'vm',
      link: function (scope, element) {
        scope.vm.chartElementId += scope.chartId; // += scope.index;
        scope.vm.showSubChart = scope.subChart ? scope.subChart : false;
        scope.vm.xAxisOptions = scope.options.x ? scope.options.x : {};
        scope.vm.chartType = scope.options.chartType
          ? scope.options.chartType
          : 'line';
        scope.vm.rotated = scope.options.rotated
          ? scope.options.rotated
          : false;
        scope.vm.leftPadding = scope.leftPadding
          ? parseInt(scope.leftPadding)
          : 70;
        scope.vm.chartDataName = scope.chartDataName
          ? scope.chartDataName
          : null;
        angular
          .element(element.find('.lineChartContainer'))
          .attr('id', scope.vm.chartElementId);
        $timeout(function () {
          scope.vm.refresh(scope.options.data);
          scope.$watch('options.data', function (newValue) {
            scope.vm.refresh(newValue);
          });
        }, 100);
      }
    };
  }

  /** @ngInject */
  function lineChartController($scope, $translate, $filter, brand) {
    var vm = this;

    vm.chart = null;
    vm.chartElementId = 'lineChart';
    vm.refresh = refreshChart;
    vm.showSubChart = false;
    vm.xAxisOptions = {};
    vm.chartType = 'line';
    vm.rotated = false;
    vm.leftPadding = 70;

    init();

    function init() {
      $scope.$on('$destroy', destroy);
    }

    function destroy() {
      if (vm.chart) {
        vm.chart.destroy();
      }
    }

    function refreshChart(data) {
      var groupColumnName = 'x',
        rowsData = [];

      if (!data) {
        return;
      }

      if (data.groupNames) {
        rowsData = [
          [groupColumnName].concat(filterWhiteSpaceNames(data.groupNames))
        ];

        data.groupsData.forEach(function (item) {
          rowsData.push([item.groupValue].concat(item.values));
        });
      } else {
        rowsData = [
          [groupColumnName].concat($translate.instant($scope.chartDataName))
        ];

        data.forEach(function (item) {
          rowsData.push([item.date].concat(item.count));
        });
      }

      var temp = vm.chartDataName ? vm.chartDataName : data.unit;
      createChart(groupColumnName, rowsData, temp);
    }

    function createChart(groupColumnName, rowsData, unit) {
      vm.chart = c3.generate({
        bindto: '#' + vm.chartElementId,
        data: {
          x: groupColumnName,
          rows: rowsData,
          type: vm.chartType
        },
        subchart: {
          show: vm.showSubChart,
          size: {
            height: 20
          }
        },
        axis: {
          rotated: vm.rotated,
          x: vm.xAxisOptions,
          y: {
            label: {
              text: '(' + $translate.instant(unit) + ')'
            },
            tick: {
              format: function (d) {
                var int = 0;
                var check = d - Math.floor(d) !== 0;
                if (check) {
                  int = 2;
                }
                return d.toFixed(int);
              }
            }
          }
        },
        padding: {
          top: 10,
          right: 50,
          bottom: 10,
          left: vm.leftPadding
        },
        size: {
          height: 360
        },
        transition: {
          duration: 0
        }
      });
    }

    function filterWhiteSpaceNames(array) {
      return array.map(function (item) {
        // Check for Karcher custom program naming and remove special characters
        return $translate.instant(
          $filter('removews')($filter('karcherCustomTranslation')(item)),
          { brand: brand }
        );
      });
    }
  }
})();
